// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-social-card-temp-js": () => import("./../../../src/pages/social-card-temp.js" /* webpackChunkName: "component---src-pages-social-card-temp-js" */),
  "component---src-templates-blog-list-mdx-tsx": () => import("./../../../src/templates/blog-list-mdx.tsx" /* webpackChunkName: "component---src-templates-blog-list-mdx-tsx" */),
  "component---src-templates-mdx-blog-post-js": () => import("./../../../src/templates/mdx-blog-post.js" /* webpackChunkName: "component---src-templates-mdx-blog-post-js" */)
}

